import Feature from "@/components/feature";
import { useState } from "react";
import useTrans from "@/hooks/useTrans";
import { useMediaQuery } from "usehooks-ts";
import variables from "/styles/variables.module.scss";

export default function SearchHub3({
  options: { searchComponent, components, style, title },
  url,
  windowDimension,
  primaryColor,
  secondaryColor,
  defaultImage,
  noDataText,
  backgroundColor,
}) {
  const [dynamicFilters, setDynamicFilters] = useState([]);
  const [sortOption, setSortOption] = useState(null);
  const isThreshold = useMediaQuery("(max-width: 1440px)");

  const trans = useTrans();
  const componentStyles = style;

  const wrapperStyle = {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: 32,
    paddingLeft: 48,
    paddingRight: 48,
    paddingBottom: 120,
  };
  const titleStyle = {
    fontSize: 48,
    fontWeight: "bold",
    textAlign: "center",
    color: variables.primaryColor,
  };

  let handleSearch = () => {};

  let searchComponentJSX = <></>;
  let componentJSX = <></>;

  if (searchComponent) {
    if (searchComponent.component === "search")
      switch (searchComponent.display) {
        case "search4":
          handleSearch = (filterArray, sortOption) => {
            setDynamicFilters([...filterArray]);
            setSortOption(sortOption);
          };

        default:
          break;
      }
    searchComponentJSX = (
      <div>
        <Feature
          url={url}
          display={searchComponent.display}
          component={searchComponent.component}
          options={{ handleSearch: handleSearch, ...searchComponent.options }}
          windowDimension={windowDimension}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          defaultImage={defaultImage}
          noDataText={noDataText}
          backgroundColor={backgroundColor}
        />
      </div>
    );
  }

  if (Array.isArray(components)) {
    componentJSX = components.map((component, index) => {
      return (
        <div
          key={index}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: component.options?.background,
          }}
        >
          <div
            style={
              !isThreshold
                ? searchComponent.options?.style
                : searchComponent.options?.altStyle
            }
          >
            <Feature
              url={url}
              display={component.display}
              component={component.component}
              options={{
                dynamicFilters:
                  component.type === "dynamic" ? dynamicFilters : [],
                ...component.options,
                sortOption: component.type === "dynamic" ? sortOption : null,
              }}
              windowDimension={windowDimension}
              primaryColor={primaryColor}
              secondaryColor={secondaryColor}
              defaultImage={defaultImage}
              noDataText={noDataText}
              backgroundColor={backgroundColor}
            />
          </div>
        </div>
      );
    });
  }

  return (
    <div
      style={{
        ...wrapperStyle,
        ...(componentStyles || {}),
      }}
    >
      <div
        style={{
          ...titleStyle,
          ...(componentStyles?.header || {}),
        }}
      >
        {title || trans.jobListTitle}
      </div>
      {searchComponentJSX}
      {componentJSX}
    </div>
  );
}
